import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { useNavigate } from 'react-router-dom'
import { PAID_DEFENSE_FEES_REPORT_QUERY } from '../../../graphql.js'
import { csvUrl, getData, getInputParams,  sortColumnClicked } from '../CustomUtils.js'
import ParameterValues from '../ParameterValues.js'
import ColumnHeadings from '../ColumnHeadings.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'

const PAID_DEFENSE_FEES_REPORT = gql(PAID_DEFENSE_FEES_REPORT_QUERY)

export default function PaidDefenseIndemnityFees({ location }) {
  console.log('PaidDefenseIndemnityFees rendered')

  const navigate = useNavigate()
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, PAID_DEFENSE_FEES_REPORT, 'paidDefenseFees', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let resultRows = []
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    })
    const alignment = ['left', 'left', 'left', 'left', 'left', 'center', 'left', 'left', 'left', 'right', 'center', 'center', 'center', 'center', 'right']
    const currencyColumns = [9, 14]
    let totalExpensesFees = 0
    let totalSettlementAmount = 0
    for (let i = 0; i < results.reportData.length; i++) {
      const row = []
      for (let j = 0; j < results.reportData[i].length; j++) {
        if (currencyColumns.includes(j)) {
          const amount = parseFloat(results.reportData[i][j])
          results.reportData[i][j] = formatter.format(amount)
          totalExpensesFees += j === 9 ? amount : 0 
          totalSettlementAmount += j === 14 ? amount : 0 
        }
        if (j === 0) {
          row.push(<td style={{ textAlign: 'right'}} key={-1}>{i+1}</td>)
        }
        row.push(<td key={j} style={{ textAlign: alignment[j] }}>{results.reportData[i][j]}</td>)
      }
      resultRows.push(<tr key={i}>{row}</tr>)
    }

    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Asbestos/paidDefenseFees/paid_defense', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={'Liberty Mutual Defense Fees Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} inputs={getInputParams(location)} sortColumnClicked={sortColumnClicked} location={location} navigate={navigate} setResults={setResults} />
            {resultRows}
            <tr key={'totals'}>
              <td colSpan="10" style={{ textAlign: 'right', fontWeight: 'bold' }}>Totals</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(totalExpensesFees)}</td>
              <td colSpan="4"></td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(totalSettlementAmount)}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    )
  }
}